const namespace = 'workflows.tags';

const translations = {
    placeholder: `${namespace}.placeholder`,
};

export { translations };
